module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-douwe-egberts-02.ef0633f8.jpg";